<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<!--blog style1 start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h2 class="title">Post <span>Style 1</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We Develop Digital Strategy</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/02.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>These guide Designing work</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/03.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We're Nominated To Agency</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog style1 end-->


<!--blog style2 start-->

<section class="grey-bg parallaxie" data-bg-img="images/pattern/03.png">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h2 class="title">Post <span>Style 2</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid pl-lg-0">
    <div class="row">
      <div class="col-lg-11 col-12 mr-auto ml-lg-n5">
        <div class="owl-carousel" data-items="2" data-md-items="1" data-sm-items="1" data-margin="30" data-autoplay="true">
          <div class="item">
            <div class="row no-gutters post style-2">
              <div class="col-sm-6">
                <div class="post-image h-100" data-bg-img="images/blog/01.jpg"></div>
              </div>
              <div class="col-sm-6">
                <div class="post-desc">
                  <div class="post-meta">
                    <ul class="list-inline">
                      <li><a href="#">Admin</a>
                      </li>
                      <li>February 08, 2020</li>
                    </ul>
                  </div>
                  <div class="post-title">
                    <h5>We Develop Digital Strategy</h5>
                  </div>
                  <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row no-gutters post style-2">
              <div class="col-sm-6">
                <div class="post-image h-100" data-bg-img="images/blog/02.jpg"></div>
              </div>
              <div class="col-sm-6">
                <div class="post-desc">
                  <div class="post-meta">
                    <ul class="list-inline">
                      <li><a href="#">Admin</a>
                      </li>
                      <li>February 08, 2020</li>
                    </ul>
                  </div>
                  <div class="post-title">
                    <h5>These guide Designing work</h5>
                  </div>
                  <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row no-gutters post style-2">
              <div class="col-sm-6">
                <div class="post-image h-100" data-bg-img="images/blog/03.jpg"></div>
              </div>
              <div class="col-sm-6">
                <div class="post-desc">
                  <div class="post-meta">
                    <ul class="list-inline">
                      <li><a href="#">Admin</a>
                      </li>
                      <li>February 08, 2020</li>
                    </ul>
                  </div>
                  <div class="post-title">
                    <h5>We're Nominated To Agency</h5>
                  </div>
                  <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog style2 end-->


<!--blog style3 start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h2 class="title">Post <span>Style 3</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="post style-3">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/04.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We Develop Digital Strategy</h5>
            </div><a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="post style-3">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/05.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>These guide Designing work</h5>
            </div><a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="post style-3">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/06.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We're Nominated To Agency</h5>
            </div><a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog style3 end-->


<!--blog style4 start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h2 class="title">Post <span>Style 4</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="post style-4">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
            <a class="post-categories" href="#">Agency</a>
          </div>
          <div class="post-desc">            
            <div class="post-title">
              <h5><a href="blog-single.html">We Develop Digital Strategy</a></h5>
            </div>
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 mt-5 mt-md-0">
        <div class="post style-4">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/02.jpg" alt="">
            <a class="post-categories" href="#">Agency</a>
          </div>
          <div class="post-desc">            
            <div class="post-title">
              <h5><a href="blog-single.html">These guide Designing work</a></h5>
            </div>
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 mt-5 mt-md-0">
        <div class="post style-4">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/03.jpg" alt="">
            <a class="post-categories" href="#">Agency</a>
          </div>
          <div class="post-desc">            
            <div class="post-title">
              <h5><a href="blog-single.html">We're Nominated To Agency</a></h5>
            </div>
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog style4 end-->

</div>

<!--body content end--> 

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            name: "shorthand-blog-post",
        }
    }
}
</script>